import { Container, Grid, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import PaperBox from "components/PaperBox"
import SubTabs from "components/SubTabs"
import { TabPanel } from "components/navigation/TabPanel"
import { apiEndpoints } from "generated/apiEndpoints"
import { useContext, useEffect, useState } from "react"
import CustomRoleList from "shared/customer/CustomRoles/CustomRoleList"
import RoleTemplatesList from "shared/customer/RoleTemplates/RoleTemplatesList"
import { CustomerForm } from "../../../../components/CustomerForm"
import { EditCustomerNavigation } from "../../components/EditCustomerNavigation"
import { useTranslation } from "react-i18next"

const EditCustomer = ({ match }) => {
  const [customerResult, customerFuncs] = useApi()
  const [saveResult, saveFuncs] = useApi()
  const [tabValue, setTabValue] = useState(0)
  const [logoResult, logoFuncs] = useApi()
  const loadingContext = useContext(GlobalLoaderContext)
  const { t } = useTranslation()

  const tabData = [
    {
      index: 0,
      label: t("settings.customer.customer_data", "Customer data"),
      queryParam: "customerSettings"
    },
    { index: 1, label: t("settings.customer.roles", "Roles"), queryParam: "roles" },
    { index: 2, label: t("settings.customer.role_templates", "Role templates"), queryParams: "roletemplates" }
  ]

  useEffect(() => {
    const getData = async () => {
      await customerFuncs.get(
        apiEndpoints.systemadmincustomers.getcustomerbyid.replace("{id}", match.params.id)
      )
    }
    getData()
  }, [customerFuncs, match.params.id])

  useEffect(() => {
    if (customerResult.data && customerResult.data.logoName) {
      logoFuncs.get(
        apiEndpoints.systemadmincustomers.getcustomerlogobyname.concat(
          "?name=" + encodeURIComponent(customerResult.data.logoName)
        )
      )
    }
  }, [customerResult, logoFuncs])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })

  useEffect(() => {
    loadingContext.setLoading(() => logoResult.status === 1)
  })

  const feedback = {
    errorTitle: "Kunde inte spara kund"
  }

  const handleSubmit = async (values) => {
    saveFuncs.put(apiEndpoints.systemadmincustomers.updatecustomer, {
      ...values
    })
  }

  return (
    <div>
      {customerResult.status === 2 && (
        <>
          <EditCustomerNavigation customerId={match.params.id} />
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h1" mb={5}>
                  {t("settings.form.title", "Customer data")}
                </Typography>
              </Grid>
            </Grid>
            <SubTabs tabs={tabData} value={tabValue} setValue={setTabValue} marginLeft={1} />
            <TabPanel value={tabValue} index={0}>
              {customerResult.status === 2 &&
                <CustomerForm
                  editCustomer={customerResult.data}
                  saveResult={saveResult}
                  feedback={feedback}
                  logoResult={logoResult}
                  handleSubmit={handleSubmit}
                />
              }
            </TabPanel>
            {customerResult.status === 2 && (
              <>
                <TabPanel value={tabValue} index={1}>
                  <Grid container>
                    <Grid item xs={12} lg={8}>
                      <PaperBox sx={{ p: 0 }} mt={0}>
                        <CustomRoleList t={t} isSystemAdmin={true} customerId={customerResult?.data?.id} />
                      </PaperBox>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                  <PaperBox sx={{ p: 0 }} mt={0}>
                    <RoleTemplatesList isSystemAdmin={true} customerId={customerResult.data.id} />
                  </PaperBox>
                </TabPanel>
              </>
            )}
          </Container>
        </>
      )}
    </div>
  )
}
export default EditCustomer
